/**
 * 根据 IP 国家返回默认语言（用于 locale 为 default 时的选中）
 * - 巴西 (BR) → 葡语 (pt)
 * - 中东 (AE/SA 等) → 英文 (en)
 * - 其他 → 英文 (en)
 */
import { getOrigin } from "utils/method";
import { Request } from "@xt/xtbase";

const IP_API_URL = getOrigin("www") + "/sapi/v4/ip/public/info/ip";

/** 巴西 → 葡语 */
const BR_LOCALE = "pt";
/** 中东及其他 → 英文 */
const DEFAULT_LOCALE = "en";

/**
 * 通过 IP 获取国家代码（与 ssr-web-index fiatMarket 一致）
 * @returns {Promise<string|null>} 如 "AE", "BR", "SA"
 */
export async function getCountryCodeByIP() {
  try {
    const response = await Request.XtAxios4.get(IP_API_URL);
    const countryCode = response?.countryCode || response?.data?.countryCode;
    return countryCode ? countryCode.toUpperCase() : null;
  } catch (error) {
    console.warn("getDefaultLocaleByIP: getCountryCodeByIP failed", error);
    return null;
  }
}

/**
 * 根据当前请求 IP 获取应使用的默认 locale
 * @returns {Promise<string>} "pt" | "en"
 */
export async function getDefaultLocaleByIP() {
  try {
    const countryCode = await getCountryCodeByIP();
    if (countryCode === "BR") return BR_LOCALE;
    return DEFAULT_LOCALE;
  } catch (e) {
    return DEFAULT_LOCALE;
  }
}
